<template>
  <iframe
    frameborder="0"
    allow="autoplay; fullscreen; vr"
    mozallowfullscreen="true"
    webkitallowfullscreen="true"
    class="iframe-model"
  ></iframe>
</template>

<script>
export default {
  name: "Iframe"
};
</script>

<style lang="scss" scoped>
$tablet: "screen and (max-width: 700px)";

.iframe-model {
  border: 0;
  height: 100%;
  left: 0;
  position: absolute;
  top: 0;
  width: 100%;
}

</style>
